module.exports = __webpack_public_path__ + "static/img/TITLE.ee3cdc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/TITLE.png
// module id = h7jX
// module chunks = 1